import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const KEY = '3dlavka_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ at: new Date().toISOString(), version: '1' }));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="cookie-banner" role="dialog" aria-label="Уведомление о файлах cookie">
      <div className="cookie-text">
        Мы используем файлы cookie и localStorage для работы корзины, входа и темы.
        Продолжая, вы соглашаетесь с этим. Подробнее — в <Link to="/legal/privacy">политике конфиденциальности</Link>.
      </div>
      <button className="btn btn-primary btn-sm" onClick={accept}>Понятно</button>
    </div>
  );
}
